import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Default_getInstancee1f46otjvolq as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { toLongOrNullutqivezb0wx1 as toLongOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  toNumber2e2hj9zugjwi2 as toNumber,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea93txwfmg154xda as Result__exceptionOrNull_impl_p6xea9,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { canceldn4b3cdqcfny as cancel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { get_isSaved1yor47kvbhumv as get_isSaved } from './SaveBody.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import {
  ConnectTimeoutException35w4gpuoa1015 as ConnectTimeoutException,
  SocketTimeoutException2zstjwq2yf3s9 as SocketTimeoutException,
} from '../network/sockets/TimeoutExceptions.nonJvm.mjs';
import { HttpRequestTimeoutException19335ch7q7rkf as HttpRequestTimeoutException } from './HttpTimeout.mjs';
import { Send_instance1oebf6ttzyqzk as Send_instance } from './api/CommonHooks.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  HttpRequest3fsc4149kgwfg as HttpRequest,
} from '../request/HttpRequest.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return LOGGER;
}
var LOGGER;
function get_HttpRequestRetryEvent() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return HttpRequestRetryEvent;
}
var HttpRequestRetryEvent;
var HttpRequestRetry;
function get_MaxRetriesPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return MaxRetriesPerRequestAttributeKey;
}
var MaxRetriesPerRequestAttributeKey;
function get_ShouldRetryPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryPerRequestAttributeKey;
}
var ShouldRetryPerRequestAttributeKey;
function get_ShouldRetryOnExceptionPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryOnExceptionPerRequestAttributeKey;
}
var ShouldRetryOnExceptionPerRequestAttributeKey;
function get_ModifyRequestPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ModifyRequestPerRequestAttributeKey;
}
var ModifyRequestPerRequestAttributeKey;
function get_RetryDelayPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return RetryDelayPerRequestAttributeKey;
}
var RetryDelayPerRequestAttributeKey;
var HttpRetryEventDataClass;
function HttpRetryEventData() {
  if (HttpRetryEventDataClass === VOID) {
    class $ {
      constructor(request, retryCount, response, cause) {
        this.request_1 = request;
        this.retryCount_1 = retryCount;
        this.response_1 = response;
        this.cause_1 = cause;
      }
    }
    initMetadataForClass($, 'HttpRetryEventData');
    HttpRetryEventDataClass = $;
  }
  return HttpRetryEventDataClass;
}
function randomMs($this, randomizationMs) {
  return randomizationMs === 0n ? 0n : Default_getInstance().nextLong_6yjhyj_k$(randomizationMs);
}
function HttpRequestRetryConfig$delay$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* delay(it, $completion);
    return Unit_instance;
  }), 1);
}
function HttpRequestRetryConfig$modifyRequest$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function HttpRequestRetryConfig$retryOnServerErrors$lambda($this$retryIf, _unused_var__etf5q3, response) {
  // Inline function 'kotlin.let' call
  var it = response.get_status_jnf6d7_k$().value_1;
  return 500 <= it ? it <= 599 : false;
}
var HttpRequestRetryConfigClass;
function HttpRequestRetryConfig() {
  if (HttpRequestRetryConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        tmp.delay_1 = HttpRequestRetryConfig$delay$slambda();
        var tmp_0 = this;
        tmp_0.modifyRequest_1 = HttpRequestRetryConfig$modifyRequest$lambda;
        this.maxRetries_1 = 0;
        this.retryOnExceptionOrServerErrors_vs25gx_k$(3);
        this.exponentialDelay$default_gkwfsg_k$();
      }
      get_shouldRetry_o4gxfl_k$() {
        var tmp = this.shouldRetry_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('shouldRetry');
        }
      }
      get_shouldRetryOnException_5ctz93_k$() {
        var tmp = this.shouldRetryOnException_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('shouldRetryOnException');
        }
      }
      get_delayMillis_llob4d_k$() {
        var tmp = this.delayMillis_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('delayMillis');
        }
      }
      retryIf_sig7v0_k$(maxRetries, block) {
        if (!(maxRetries === -1))
          this.maxRetries_1 = maxRetries;
        this.shouldRetry_1 = block;
      }
      retryOnExceptionIf_wpc295_k$(maxRetries, block) {
        if (!(maxRetries === -1))
          this.maxRetries_1 = maxRetries;
        this.shouldRetryOnException_1 = block;
      }
      retryOnException_34fdi3_k$(maxRetries, retryOnTimeout) {
        this.retryOnExceptionIf_wpc295_k$(maxRetries, ($this$retryOnExceptionIf, _unused_var__etf5q3, cause) => {
          var tmp;
          if (isTimeoutException(cause)) {
            tmp = retryOnTimeout;
          } else {
            if (cause instanceof CancellationException()) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
          return tmp;
        });
      }
      retryOnException$default_fu1qg9_k$(maxRetries, retryOnTimeout, $super) {
        maxRetries = maxRetries === VOID ? -1 : maxRetries;
        retryOnTimeout = retryOnTimeout === VOID ? false : retryOnTimeout;
        var tmp;
        if ($super === VOID) {
          this.retryOnException_34fdi3_k$(maxRetries, retryOnTimeout);
          tmp = Unit_instance;
        } else {
          tmp = $super.retryOnException_34fdi3_k$.call(this, maxRetries, retryOnTimeout);
        }
        return tmp;
      }
      retryOnServerErrors_n8g6l_k$(maxRetries) {
        this.retryIf_sig7v0_k$(maxRetries, HttpRequestRetryConfig$retryOnServerErrors$lambda);
      }
      retryOnExceptionOrServerErrors_vs25gx_k$(maxRetries) {
        this.retryOnServerErrors_n8g6l_k$(maxRetries);
        this.retryOnException$default_fu1qg9_k$(maxRetries);
      }
      delayMillis_83rww5_k$(respectRetryAfterHeader, block) {
        var tmp = this;
        tmp.delayMillis_1 = (_this__u8e3s4, it) => {
          var tmp;
          if (respectRetryAfterHeader) {
            var tmp0_safe_receiver = _this__u8e3s4.response_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_headers_ef25jx_k$();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_6bo4tg_k$('Retry-After');
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toLongOrNull(tmp2_safe_receiver);
            var tmp_0;
            if (tmp3_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.Long.times' call
              tmp_0 = multiply(tmp3_safe_receiver, fromInt(1000));
            }
            var retryAfter = tmp_0;
            var tmp0 = block(_this__u8e3s4, it);
            // Inline function 'kotlin.comparisons.maxOf' call
            var b = retryAfter == null ? 0n : retryAfter;
            tmp = tmp0 >= b ? tmp0 : b;
          } else {
            tmp = block(_this__u8e3s4, it);
          }
          return tmp;
        };
      }
      exponentialDelay_uk8dy1_k$(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader) {
        // Inline function 'kotlin.check' call
        if (!(base > 0)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(baseDelayMs > 0n)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(maxDelayMs > 0n)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(randomizationMs >= 0n)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        this.delayMillis_83rww5_k$(respectRetryAfterHeader, ($this$delayMillis, retry) => {
          var tmp0 = base;
          // Inline function 'kotlin.math.pow' call
          var n = retry - 1 | 0;
          var tmp$ret$4 = Math.pow(tmp0, n);
          var tmp0_0 = numberToLong(tmp$ret$4 * toNumber(baseDelayMs));
          // Inline function 'kotlin.comparisons.minOf' call
          var b = maxDelayMs;
          var delay = tmp0_0 <= b ? tmp0_0 : b;
          return add(delay, randomMs(this, randomizationMs));
        });
      }
      exponentialDelay$default_gkwfsg_k$(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader, $super) {
        base = base === VOID ? 2.0 : base;
        baseDelayMs = baseDelayMs === VOID ? 1000n : baseDelayMs;
        maxDelayMs = maxDelayMs === VOID ? 60000n : maxDelayMs;
        randomizationMs = randomizationMs === VOID ? 1000n : randomizationMs;
        respectRetryAfterHeader = respectRetryAfterHeader === VOID ? true : respectRetryAfterHeader;
        var tmp;
        if ($super === VOID) {
          this.exponentialDelay_uk8dy1_k$(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
          tmp = Unit_instance;
        } else {
          tmp = $super.exponentialDelay_uk8dy1_k$.call(this, base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpRequestRetryConfig', HttpRequestRetryConfig);
    HttpRequestRetryConfigClass = $;
  }
  return HttpRequestRetryConfigClass;
}
var HttpRetryShouldRetryContextClass;
function HttpRetryShouldRetryContext() {
  if (HttpRetryShouldRetryContextClass === VOID) {
    class $ {
      constructor(retryCount) {
        this.retryCount_1 = retryCount;
      }
    }
    initMetadataForClass($, 'HttpRetryShouldRetryContext');
    HttpRetryShouldRetryContextClass = $;
  }
  return HttpRetryShouldRetryContextClass;
}
var HttpRetryDelayContextClass;
function HttpRetryDelayContext() {
  if (HttpRetryDelayContextClass === VOID) {
    class $ {
      constructor(request, response, cause) {
        this.request_1 = request;
        this.response_1 = response;
        this.cause_1 = cause;
      }
    }
    initMetadataForClass($, 'HttpRetryDelayContext');
    HttpRetryDelayContextClass = $;
  }
  return HttpRetryDelayContextClass;
}
var HttpRetryModifyRequestContextClass;
function HttpRetryModifyRequestContext() {
  if (HttpRetryModifyRequestContextClass === VOID) {
    class $ {
      constructor(request, response, cause, retryCount) {
        this.request_1 = request;
        this.response_1 = response;
        this.cause_1 = cause;
        this.retryCount_1 = retryCount;
      }
    }
    initMetadataForClass($, 'HttpRetryModifyRequestContext');
    HttpRetryModifyRequestContextClass = $;
  }
  return HttpRetryModifyRequestContextClass;
}
function *throwOnInvalidResponseBody(_this__u8e3s4, $completion) {
  var tmp;
  if (get_isSaved(_this__u8e3s4)) {
    // Inline function 'kotlin.run' call
    var $this$run = _this__u8e3s4.get_rawContent_u3f8li_k$();
    var tmp_0;
    try {
      tmp_0 = yield* $this$run.awaitContent$default_rxihsg_k$(VOID, $completion);
    }finally {
      // Inline function 'kotlin.runCatching' call
      var tmp_1;
      try {
        cancel($this$run);
        // Inline function 'kotlin.Companion.success' call
        tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      // Inline function 'kotlin.onFailure' call
      var this_0 = tmp_1;
      var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        get_LOGGER().debug_2dc8ew_k$('Failed to close response body channel', tmp0_safe_receiver);
      }
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
function isTimeoutException(_this__u8e3s4) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var exception = unwrapCancellationException(_this__u8e3s4);
  var tmp;
  var tmp_0;
  if (exception instanceof HttpRequestTimeoutException()) {
    tmp_0 = true;
  } else {
    tmp_0 = exception instanceof ConnectTimeoutException();
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = exception instanceof SocketTimeoutException();
  }
  return tmp;
}
function HttpRequestRetryConfig$_init_$ref_mqbboi() {
  return constructCallableReference(() => new (HttpRequestRetryConfig())(), 0, 0, 221, '<init>');
}
function HttpRequestRetry$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var shouldRetry = $this$createClientPlugin.pluginConfig_1.get_shouldRetry_o4gxfl_k$();
  var shouldRetryOnException = $this$createClientPlugin.pluginConfig_1.get_shouldRetryOnException_5ctz93_k$();
  var delayMillis = $this$createClientPlugin.pluginConfig_1.get_delayMillis_llob4d_k$();
  var delay = $this$createClientPlugin.pluginConfig_1.delay_1;
  var maxRetries = $this$createClientPlugin.pluginConfig_1.maxRetries_1;
  var modifyRequest = $this$createClientPlugin.pluginConfig_1.modifyRequest_1;
  $this$createClientPlugin.onRequest_fk8bil_k$(HttpRequestRetry$lambda$slambda(maxRetries));
  var tmp = Send_instance;
  $this$createClientPlugin.on_z1oiz_k$(tmp, HttpRequestRetry$lambda$slambda_0(shouldRetry, shouldRetryOnException, maxRetries, delayMillis, modifyRequest, $this$createClientPlugin, delay));
  return Unit_instance;
}
function invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call) {
  return retryCount < maxRetries && shouldRetry(new (HttpRetryShouldRetryContext())(retryCount + 1 | 0), call.get_request_jdwg4m_k$(), call.get_response_xlk07e_k$());
}
function invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetry, subRequest, cause) {
  return retryCount < maxRetries && shouldRetry(new (HttpRetryShouldRetryContext())(retryCount + 1 | 0), subRequest, cause);
}
function invoke$prepareRequest(request) {
  var subRequest = (new (HttpRequestBuilder())()).takeFrom_mkv7jk_k$(request);
  var tmp = request.executionContext_1;
  tmp.invokeOnCompletion_n6cffu_k$((cause) => {
    var tmp = subRequest.executionContext_1;
    var subRequestJob = isInterface(tmp, CompletableJob()) ? tmp : THROW_CCE();
    if (cause == null) {
      subRequestJob.complete_9ww6vb_k$();
    } else {
      subRequestJob.completeExceptionally_xyzekf_k$(cause);
    }
    return Unit_instance;
  });
  return subRequest;
}
function HttpRequestRetry$lambda$slambda($maxRetries) {
  return constructCallableReference(($this$onRequest, request, _unused_var__etf5q3, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = request.attributes_1.getOrNull_6mjt1v_k$(get_MaxRetriesPerRequestAttributeKey());
    var maxRetriesValue = tmp0_elvis_lhs == null ? $maxRetries : tmp0_elvis_lhs;
    request.attributes_1.put_gkntno_k$(get_MaxRetriesPerRequestAttributeKey(), maxRetriesValue);
    return Unit_instance;
  }), 3);
}
function HttpRequestRetry$lambda$slambda_0($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay) {
  return constructCallableReference(($this$on, request, $completion) => orPromise($completion, function *($completion) {
    var retryCount = 0;
    var tmp0_elvis_lhs = request.attributes_1.getOrNull_6mjt1v_k$(get_ShouldRetryPerRequestAttributeKey());
    var shouldRetry = tmp0_elvis_lhs == null ? $shouldRetry : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = request.attributes_1.getOrNull_6mjt1v_k$(get_ShouldRetryOnExceptionPerRequestAttributeKey());
    var shouldRetryOnException = tmp1_elvis_lhs == null ? $shouldRetryOnException : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = request.attributes_1.getOrNull_6mjt1v_k$(get_MaxRetriesPerRequestAttributeKey());
    var maxRetries = tmp2_elvis_lhs == null ? $maxRetries : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = request.attributes_1.getOrNull_6mjt1v_k$(get_RetryDelayPerRequestAttributeKey());
    var delayMillis = tmp3_elvis_lhs == null ? $delayMillis : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = request.attributes_1.getOrNull_6mjt1v_k$(get_ModifyRequestPerRequestAttributeKey());
    var modifyRequest = tmp4_elvis_lhs == null ? $modifyRequest : tmp4_elvis_lhs;
    var call;
    var lastRetryData = null;
    $l$loop: while (true) {
      var subRequest = invoke$prepareRequest(request);
      var tmp;
      try {
        if (!(lastRetryData == null)) {
          var modifyRequestContext = new (HttpRetryModifyRequestContext())(request, lastRetryData.response_1, lastRetryData.cause_1, lastRetryData.retryCount_1);
          modifyRequest(modifyRequestContext, subRequest);
        }
        call = yield* $this$on.proceed_g307xy_k$(subRequest, $completion);
        if (!invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call)) {
          yield* /*#__NOINLINE__*/throwOnInvalidResponseBody(call.get_response_xlk07e_k$(), $completion);
          break $l$loop;
        }
        retryCount = retryCount + 1 | 0;
        tmp = new (HttpRetryEventData())(subRequest, retryCount, call.get_response_xlk07e_k$(), null);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var cause = $p;
          if (!invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetryOnException, subRequest, cause)) {
            throw cause;
          }
          retryCount = retryCount + 1 | 0;
          tmp_0 = new (HttpRetryEventData())(subRequest, retryCount, null, cause);
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var retryData = tmp;
      lastRetryData = retryData;
      $this_createClientPlugin.client_1.monitor_1.raise_3e7w7u_k$(get_HttpRequestRetryEvent(), lastRetryData);
      var delayContext = new (HttpRetryDelayContext())(lastRetryData.request_1, lastRetryData.response_1, lastRetryData.cause_1);
      yield* $($delay(delayMillis(delayContext, retryCount), $completion), $completion);
      // Inline function 'io.ktor.util.logging.trace' call
      var this_0 = get_LOGGER();
      if (get_isTraceEnabled(this_0)) {
        var tmp$ret$1 = 'Retrying request ' + request.url_1.toString() + ' attempt: ' + retryCount;
        this_0.trace_fti9bv_k$(tmp$ret$1);
      }
    }
    return call;
  }), 2);
}
var properties_initialized_HttpRequestRetry_kt_jcpv6l;
function _init_properties_HttpRequestRetry_kt__h4xjtt() {
  if (!properties_initialized_HttpRequestRetry_kt_jcpv6l) {
    properties_initialized_HttpRequestRetry_kt_jcpv6l = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestRetry');
    HttpRequestRetryEvent = new (EventDefinition())();
    var tmp = HttpRequestRetryConfig$_init_$ref_mqbboi();
    HttpRequestRetry = createClientPlugin('RetryFeature', tmp, HttpRequestRetry$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'MaxRetriesPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$();
    var tmp_1 = !(null == null) ? typeof null === 'number' : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_2;
    try {
      tmp_2 = createKType(PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$(), arrayOf([]), false);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_3 = null;
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    var tmp$ret$2 = tmp_2;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
    MaxRetriesPerRequestAttributeKey = new (AttributeKey())(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'ShouldRetryPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_4 = PrimitiveClasses_getInstance().functionClass(3);
    var tmp_5 = !(null == null) ? typeof null === 'function' : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_6;
    try {
      tmp_6 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequest()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpResponse()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_booleanClass_d285fr_k$(), arrayOf([]), false))]), false);
    } catch ($p_0) {
      var tmp_7;
      if ($p_0 instanceof Error) {
        var _unused_var__etf5q3_0 = $p_0;
        tmp_7 = null;
      } else {
        throw $p_0;
      }
      tmp_6 = tmp_7;
    }
    var tmp$ret$2_0 = tmp_6;
    var tmp$ret$1_0 = new (TypeInfo())(tmp_4, tmp_5, tmp$ret$2_0);
    ShouldRetryPerRequestAttributeKey = new (AttributeKey())(name_0, tmp$ret$1_0);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_1 = 'ShouldRetryOnExceptionPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_8 = PrimitiveClasses_getInstance().functionClass(3);
    var tmp_9 = !(null == null) ? typeof null === 'function' : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_10;
    try {
      tmp_10 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_throwableClass_ee1a8x_k$(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_booleanClass_d285fr_k$(), arrayOf([]), false))]), false);
    } catch ($p_1) {
      var tmp_11;
      if ($p_1 instanceof Error) {
        var _unused_var__etf5q3_1 = $p_1;
        tmp_11 = null;
      } else {
        throw $p_1;
      }
      tmp_10 = tmp_11;
    }
    var tmp$ret$2_1 = tmp_10;
    var tmp$ret$1_1 = new (TypeInfo())(tmp_8, tmp_9, tmp$ret$2_1);
    ShouldRetryOnExceptionPerRequestAttributeKey = new (AttributeKey())(name_1, tmp$ret$1_1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_2 = 'ModifyRequestPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_12 = PrimitiveClasses_getInstance().functionClass(2);
    var tmp_13 = !(null == null) ? typeof null === 'function' : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_14;
    try {
      tmp_14 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryModifyRequestContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit()), arrayOf([]), false))]), false);
    } catch ($p_2) {
      var tmp_15;
      if ($p_2 instanceof Error) {
        var _unused_var__etf5q3_2 = $p_2;
        tmp_15 = null;
      } else {
        throw $p_2;
      }
      tmp_14 = tmp_15;
    }
    var tmp$ret$2_2 = tmp_14;
    var tmp$ret$1_2 = new (TypeInfo())(tmp_12, tmp_13, tmp$ret$2_2);
    ModifyRequestPerRequestAttributeKey = new (AttributeKey())(name_2, tmp$ret$1_2);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_3 = 'RetryDelayPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_16 = PrimitiveClasses_getInstance().functionClass(2);
    var tmp_17 = !(null == null) ? typeof null === 'function' : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_18;
    try {
      tmp_18 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryDelayContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_longClass_a79cj7_k$(), arrayOf([]), false))]), false);
    } catch ($p_3) {
      var tmp_19;
      if ($p_3 instanceof Error) {
        var _unused_var__etf5q3_3 = $p_3;
        tmp_19 = null;
      } else {
        throw $p_3;
      }
      tmp_18 = tmp_19;
    }
    var tmp$ret$2_3 = tmp_18;
    var tmp$ret$1_3 = new (TypeInfo())(tmp_16, tmp_17, tmp$ret$2_3);
    RetryDelayPerRequestAttributeKey = new (AttributeKey())(name_3, tmp$ret$1_3);
  }
}
//region block: exports
export {
  get_MaxRetriesPerRequestAttributeKey as get_MaxRetriesPerRequestAttributeKey13gphm9kuo852,
};
//endregion

//# sourceMappingURL=HttpRequestRetry.mjs.map
